/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _circle, _circle2, _circle3, _path71, _path72, _path73, _path74, _circle4, _circle5, _circle6, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _circle7, _circle8, _circle9, _circle0, _path114, _path115, _circle1, _circle10, _circle11, _circle12, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _circle13, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _circle14, _circle15, _circle16, _circle17, _circle18, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _circle19, _circle20, _circle21, _path204, _path205, _path206, _circle22, _circle23, _circle24, _path207, _circle25, _circle26, _circle27, _circle28, _circle29, _path208, _path209, _path210, _path211, _circle30, _path212, _path213, _circle31, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _circle32, _circle33, _circle34, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _circle35, _path257, _path258, _circle36, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _circle37, _path289, _circle38, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317;
const FlashFilled = /*#__PURE__*/React.forwardRef(function FlashFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlashFilled.propTypes = iconPropTypes;
}
const FlashOff = /*#__PURE__*/React.forwardRef(function FlashOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.13,6.89,11.8,4h8l-2,9H23l-2.49,3.25,1.43,1.43,3.87-5.07a1,1,0,0,0,.11-1A1,1,0,0,0,25,11H20.25L22,3.22a1,1,0,0,0-.2-.85A1,1,0,0,0,21,2H11a1,1,0,0,0-1,.77L9.46,5.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.59l-9.31-9.31h0l-1.42-1.43h0L10.6,9.19h0L8.93,7.52h0L3.41,2,2,3.41,8.4,9.82,7,15.77A1,1,0,0,0,8,17h4.83L11,28.85a1,1,0,0,0,.6,1.07A1.09,1.09,0,0,0,12,30a1,1,0,0,0,.79-.39l6.68-8.73L28.59,30ZM9.26,15l.81-3.52L13.59,15Zm4.32,10.28L15,16.37,18,19.45Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlashOff.propTypes = iconPropTypes;
}
const FlashOffFilled = /*#__PURE__*/React.forwardRef(function FlashOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.59,3.41,2,2,3.41,8.4,9.82,7,15.77A1,1,0,0,0,8,17h4.83L11,28.85a1,1,0,0,0,.6,1.07A1.09,1.09,0,0,0,12,30a1,1,0,0,0,.79-.39l6.68-8.73L28.59,30Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53,16.87l3.26-4.26a1,1,0,0,0,.11-1A1,1,0,0,0,25,11H20.25L22,3.22a1,1,0,0,0-.2-.85A1,1,0,0,0,21,2H11a1,1,0,0,0-1,.77l-.3,1.3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlashOffFilled.propTypes = iconPropTypes;
}
const FlightInternational = /*#__PURE__*/React.forwardRef(function FlightInternational({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlightInternational.propTypes = iconPropTypes;
}
const FlightRoster = /*#__PURE__*/React.forwardRef(function FlightRoster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H16V20H10z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H22V16H10z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22,10v2H10V10Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlightRoster.propTypes = iconPropTypes;
}
const FlightSchedule = /*#__PURE__*/React.forwardRef(function FlightSchedule({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlightSchedule.propTypes = iconPropTypes;
}
const FloatingIp = /*#__PURE__*/React.forwardRef(function FloatingIp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FloatingIp.propTypes = iconPropTypes;
}
const Flood = /*#__PURE__*/React.forwardRef(function Flood({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13.63,29.7573,15,31,13.4282,16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6907,3.6907,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21H28Zm-6.0513,5.0532a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.37,3.37,0,0,1-3.0021-2.19L6,12.0615l9.991-7.79L26,12.0718,26.0017,21H25A3.4376,3.4376,0,0,1,21.9487,18.6836Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Flood.propTypes = iconPropTypes;
}
const FloodWarning = /*#__PURE__*/React.forwardRef(function FloodWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FloodWarning.propTypes = iconPropTypes;
}
const Floorplan = /*#__PURE__*/React.forwardRef(function Floorplan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4 h14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Floorplan.propTypes = iconPropTypes;
}
const Flow = /*#__PURE__*/React.forwardRef(function Flow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Flow.propTypes = iconPropTypes;
}
const FlowConnection = /*#__PURE__*/React.forwardRef(function FlowConnection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowConnection.propTypes = iconPropTypes;
}
const FlowData = /*#__PURE__*/React.forwardRef(function FlowData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowData.propTypes = iconPropTypes;
}
const FlowModeler = /*#__PURE__*/React.forwardRef(function FlowModeler({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10H2V2h8ZM4,8H8V4H4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V22h8Zm-6-2h4V24H24Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H8A6,6,0,0,1,8,15v2a4,4,0,0,0,0,8H20Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17V15a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19,11H13l-3,4,6,6,6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowModeler.propTypes = iconPropTypes;
}
const FlowModelerReference = /*#__PURE__*/React.forwardRef(function FlowModelerReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V22h8Zm-6-2h4V24H24Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19,11H13l-3,4,6,6,6-6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17V15a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10H2V2h8ZM4,8H8V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowModelerReference.propTypes = iconPropTypes;
}
const FlowStream = /*#__PURE__*/React.forwardRef(function FlowStream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20,24H11.8625a4.13,4.13,0,0,0-.4284-1.02L21.98,12.4343A3.9943,3.9943,0,1,0,20.1414,8H14v2h6.1414a3.96,3.96,0,0,0,.4243,1.02L10.02,21.5656A3.9943,3.9943,0,1,0,11.8587,26H20v3h8V21H20ZM24,7a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,24,7ZM8,27a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,27Zm14-4h4v4H22Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6929,12.7505a5,5,0,0,1-.0005-7.5L11.0166,6.75a3,3,0,0,0-.0005,4.501Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowStream.propTypes = iconPropTypes;
}
const FlowStreamReference = /*#__PURE__*/React.forwardRef(function FlowStreamReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20,24H16v2h4v3h8V21H20Zm2-1h4v4H22Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24,5a3.9962,3.9962,0,0,0-3.8579,3H14v2h6.1421a3.94,3.94,0,0,0,.4248,1.019L14,17.5862,15.4138,19l6.5672-6.5669A3.9521,3.9521,0,0,0,24,13a4,4,0,0,0,0-8Zm0,6a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,11Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6929,12.7505a5,5,0,0,1-.0005-7.5L11.0166,6.75a3,3,0,0,0-.0005,4.501Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0474,15.751a9,9,0,0,1,0-13.501l1.3232,1.5a7,7,0,0,0,0,10.501Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowStreamReference.propTypes = iconPropTypes;
}
const FlowLogsVpc = /*#__PURE__*/React.forwardRef(function FlowLogsVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H30V21H18z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H30V25H18z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27H26V29H18z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24,4a3.9962,3.9962,0,0,0-3.8579,3H12V4H4v8h8V9h8.1421a3.94,3.94,0,0,0,.4248,1.019L10.019,20.5669A3.9521,3.9521,0,0,0,8,20a4,4,0,1,0,3.8579,5H16V23H11.8579a3.94,3.94,0,0,0-.4248-1.019L21.981,11.4331A3.9521,3.9521,0,0,0,24,12a4,4,0,0,0,0-8ZM10,10H6V6h4ZM8,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,8,26ZM24,10a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,24,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FlowLogsVpc.propTypes = iconPropTypes;
}
const Fog = /*#__PURE__*/React.forwardRef(function Fog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,11.1382a8.9938,8.9938,0,0,0-17.6006,0A6.533,6.533,0,0,0,2,17.5H2V19a1,1,0,0,0,1,1H15a1,1,0,0,0,0-2H4v-.4966H4a4.5176,4.5176,0,0,1,4.144-4.4819l.8155-.064.0991-.812a6.9936,6.9936,0,0,1,13.8838,0l.0986.812.8154.064A4.4962,4.4962,0,0,1,23.5,22H7a1,1,0,0,0,0,2H23.5a6.4963,6.4963,0,0,0,1.3008-12.8618Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "18",
    height: "2",
    x: "2",
    y: "26",
    rx: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fog.propTypes = iconPropTypes;
}
const Folder = /*#__PURE__*/React.forwardRef(function Folder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Folder.propTypes = iconPropTypes;
}
const FolderAdd = /*#__PURE__*/React.forwardRef(function FolderAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20L24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26 30 24 26 24z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h14v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8 C30,8.9,29.1,8,28,8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderAdd.propTypes = iconPropTypes;
}
const FolderDetails = /*#__PURE__*/React.forwardRef(function FolderDetails({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H30V22H16z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H30V26H16z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H23V30H16z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26H4V6h7.17l3.42,3.41.58.59H28v8h2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderDetails.propTypes = iconPropTypes;
}
const FolderDetailsReference = /*#__PURE__*/React.forwardRef(function FolderDetailsReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H23V30H16z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H30V26H16z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H30V22H16z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16L12.5859,4.5859A2.0007,2.0007,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V18H4V6h7.1716l3.4141,3.4141L15.1716,10H28v8h2V10A2,2,0,0,0,28,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderDetailsReference.propTypes = iconPropTypes;
}
const FolderMoveTo = /*#__PURE__*/React.forwardRef(function FolderMoveTo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13L16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderMoveTo.propTypes = iconPropTypes;
}
const FolderOff = /*#__PURE__*/React.forwardRef(function FolderOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H25.4141L30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Zm0,18H7.4141l16-16H28Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6h7.1716l3.4141,3.4141L15.1716,10H18V8H16L12.5859,4.5859A2.0007,2.0007,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V24H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderOff.propTypes = iconPropTypes;
}
const FolderOpen = /*#__PURE__*/React.forwardRef(function FolderOpen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H20.8284L17.4143,4.5859A2,2,0,0,0,16,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM8,26V14h8v6.17l-2.59-2.58L12,19l5,5,5-5-1.41-1.41L18,20.17V14a2.0025,2.0025,0,0,0-2-2H8a2.0025,2.0025,0,0,0-2,2V26H4V6H16l4,4h8v2H22v2h6V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderOpen.propTypes = iconPropTypes;
}
const FolderParent = /*#__PURE__*/React.forwardRef(function FolderParent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16L12.5857,4.5857A2,2,0,0,0,11.1716,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V16.83l2.59,2.58L22,18l-5-5-5,5,1.41,1.41L16,16.83V26H4V6h7.1716l4,4H28V26H22v2h6a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderParent.propTypes = iconPropTypes;
}
const FolderShared = /*#__PURE__*/React.forwardRef(function FolderShared({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16L12.59,4.59A2,2,0,0,0,11.17,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM22,26H14V25a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm6,0H24V25a3,3,0,0,0-3-3H15a3,3,0,0,0-3,3v1H4V6h7.17l3.42,3.41.58.59H28Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14,17a4,4,0,1,0,4-4A4,4,0,0,0,14,17Zm4-2a2,2,0,1,1-2,2A2,2,0,0,1,18,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FolderShared.propTypes = iconPropTypes;
}
const Folders = /*#__PURE__*/React.forwardRef(function Folders({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V11A2.0021,2.0021,0,0,1,6,9h5.6665a2.0119,2.0119,0,0,1,1.2007.4L16.3335,12H26a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28ZM11.6665,11H5.9985L6,26H26V14H15.6665Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H17.6665l-4-3H6V4h7.6665a2.0119,2.0119,0,0,1,1.2007.4L18.3335,7H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Folders.propTypes = iconPropTypes;
}
const ForLoop = /*#__PURE__*/React.forwardRef(function ForLoop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h7v7h-2v-3.3516c-1.6448,2.0405-4.1526,3.3516-7.0002,3.3516h-9.9998c-5,0-9-4-9-9v-8h2v8c0,3.8999,3.1001,7,7,7h10c2.4033,0,4.4941-1.1841,5.7517-3h-3.7517v-2ZM21,2h-9.9998c-2.8477,0-5.3555,1.311-7.0002,3.3516v-3.3516h-2v7h7v-2h-3.7517c1.2576-1.8159,3.3484-3,5.7517-3h10c3.8999,0,7,3.1001,7,7v8h2v-8c0-5-4-9-9-9ZM20.7212,12.0117v-2.0117h-7.7212v12h2.27v-5.0732h4.7461v-2.0117h-4.7461v-2.9033h5.4512Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForLoop.propTypes = iconPropTypes;
}
const ForecastHail = /*#__PURE__*/React.forwardRef(function ForecastHail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "14.5",
    cy: "23.5",
    r: "1.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "19.5",
    r: "1.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "17.5",
    cy: "19.5",
    r: "1.5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.964 14.5H18.036V16.499H12.964z",
    transform: "rotate(-45 15.5 15.5)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.964 14.5H24.035999999999998V16.499H18.964z",
    transform: "rotate(-45 21.5 15.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastHail.propTypes = iconPropTypes;
}
const ForecastHail_30 = /*#__PURE__*/React.forwardRef(function ForecastHail_30({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M8.964 13.5H14.036000000000001V15.499H8.964z",
    transform: "rotate(-45 11.5 14.5)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M15.379 14.5H17.622V16.499H15.379z",
    transform: "rotate(-44.995 16.5 15.5)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "22.5",
    r: "1.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "18.5",
    r: "1.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "18.5",
    r: "1.5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H16v2h4v2H17v2h3v2H16v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,20,20Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H26a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30Zm-2-8v6h2V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastHail_30.propTypes = iconPropTypes;
}
const ForecastLightning = /*#__PURE__*/React.forwardRef(function ForecastLightning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 24L13.934 23 16.221 19 12.332 19 16.325 12 18.062 13 15.778 17 19.668 17 15.67 24z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastLightning.propTypes = iconPropTypes;
}
const ForecastLightning_30 = /*#__PURE__*/React.forwardRef(function ForecastLightning_30({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28A10,10,0,0,1,14,8h4v5l6-6L18,1V6H14a12,12,0,0,0,0,24Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 24L9.934 23 12.221 19 8.332 19 12.325 12 14.062 13 11.778 17 15.668 17 11.67 24z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H16v2h4v2H17v2h3v2H16v2h4a2.0027,2.0027,0,0,0,2-2V22A2.0023,2.0023,0,0,0,20,20Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H26a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30Zm-2-8v6h2V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForecastLightning_30.propTypes = iconPropTypes;
}
const Fork = /*#__PURE__*/React.forwardRef(function Fork({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,6c0,1.8584,1.2798,3.4106,3,3.8579v5.1421h-14v-5.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v5.1421c0,1.103.897,2,2,2h6v5.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4s4-1.7944,4-4c0-1.8584-1.2798-3.4106-3-3.8579v-5.1421h6c1.103,0,2-.897,2-2v-5.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4Zm-14,0c0-1.103.897-2,2-2s2,.897,2,2c0,1.103-.897,2-2,2s-2-.897-2-2Zm12,20c0,1.103-.897,2-2,2s-2-.897-2-2c0-1.103.897-2,2-2s2,.897,2,2ZM26,6c0,1.103-.897,2-2,2s-2-.897-2-2c0-1.103.897-2,2-2s2,.897,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fork.propTypes = iconPropTypes;
}
const ForkNode = /*#__PURE__*/React.forwardRef(function ForkNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M26 21H30V23H26z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M26 9H30V11H26z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M24 11L24 9 20 9 20 4 14 4 14 28 20 28 20 23 24 23 24 21 20 21 20 11 24 11z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10.1719 15L2 15 2 17 10.1719 17 7.5859 19.5859 9 21 14 16 9 11 7.5859 12.4141 10.1719 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ForkNode.propTypes = iconPropTypes;
}
const Forum = /*#__PURE__*/React.forwardRef(function Forum({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H8C6.8,6,6,6.8,6,8v14c0,1.2,0.8,2,2,2h8v-2H8V8h20v14h-7.2L16,28.8l1.6,1.2l4.2-6H28c1.2,0,2-0.8,2-2V8 C30,6.8,29.2,6,28,6z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V5c0-1.7,1.3-3,3-3h13v2H5C4.4,4,4,4.4,4,5V18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forum.propTypes = iconPropTypes;
}
const Forward_10 = /*#__PURE__*/React.forwardRef(function Forward_10({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,22.13a2.84,2.84,0,0,1-1.28-.27,2.44,2.44,0,0,1-.89-.77,3.57,3.57,0,0,1-.52-1.25,7.69,7.69,0,0,1-.17-1.68,7.83,7.83,0,0,1,.17-1.68,3.65,3.65,0,0,1,.52-1.25,2.44,2.44,0,0,1,.89-.77,2.84,2.84,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.23,5.23,0,0,1,.7,2.93,5.23,5.23,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.63,22.13Zm0-1.22a1.07,1.07,0,0,0,1-.55A3.38,3.38,0,0,0,21,18.85V17.47a3.31,3.31,0,0,0-.29-1.5,1.23,1.23,0,0,0-2.06,0,3.31,3.31,0,0,0-.29,1.5v1.38a3.38,3.38,0,0,0,.29,1.51A1.06,1.06,0,0,0,19.63,20.91Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63,22V20.82h2V15.63l-1.86,1-.55-1.06,2.32-1.3H14v6.5h1.78V22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forward_10.propTypes = iconPropTypes;
}
const Forward_30 = /*#__PURE__*/React.forwardRef(function Forward_30({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64,22.13a2.81,2.81,0,0,1-1.28-.27,2.36,2.36,0,0,1-.89-.77A3.39,3.39,0,0,1,17,19.84a7.12,7.12,0,0,1-.17-1.68A7.24,7.24,0,0,1,17,16.48a3.46,3.46,0,0,1,.52-1.25,2.36,2.36,0,0,1,.89-.77,2.81,2.81,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.31,5.31,0,0,1,.7,2.93,5.31,5.31,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.64,22.13Zm0-1.22a1,1,0,0,0,1-.55,3.24,3.24,0,0,0,.3-1.51V17.47a3.17,3.17,0,0,0-.3-1.5,1.22,1.22,0,0,0-2.05,0,3.18,3.18,0,0,0-.29,1.5v1.38a3.25,3.25,0,0,0,.29,1.51A1,1,0,0,0,19.64,20.91Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12.62,17.42a1.46,1.46,0,0,0,1-.27.84.84,0,0,0,.31-.68v-.08a.94.94,0,0,0-.3-.74,1.2,1.2,0,0,0-.83-.27,1.65,1.65,0,0,0-.89.24,2.1,2.1,0,0,0-.68.68l-.93-.83a5.37,5.37,0,0,1,.44-.51,2.7,2.7,0,0,1,.54-.4,2.55,2.55,0,0,1,.7-.27,3.25,3.25,0,0,1,.87-.1,3.94,3.94,0,0,1,1.06.14,2.33,2.33,0,0,1,.82.4,1.91,1.91,0,0,1,.54.63,1.87,1.87,0,0,1,.18.83,2,2,0,0,1-.11.67,1.82,1.82,0,0,1-.32.52,1.79,1.79,0,0,1-.47.36,2.27,2.27,0,0,1-.57.2V18a2.34,2.34,0,0,1,.63.21,1.7,1.7,0,0,1,.51.38,1.89,1.89,0,0,1,.34.55,2.07,2.07,0,0,1,.12.73,2,2,0,0,1-.2.92,2,2,0,0,1-.58.72,2.66,2.66,0,0,1-.89.45,3.76,3.76,0,0,1-1.15.16,4.1,4.1,0,0,1-1-.11A3.1,3.1,0,0,1,11,21.7a2.76,2.76,0,0,1-.56-.45A4.22,4.22,0,0,1,10,20.7l1.07-.81a3.07,3.07,0,0,0,.28.42,1.94,1.94,0,0,0,.36.34,1.57,1.57,0,0,0,.45.22,2,2,0,0,0,.57.07,1.45,1.45,0,0,0,1-.3,1.12,1.12,0,0,0,.34-.85v-.08a1,1,0,0,0-.37-.8,1.78,1.78,0,0,0-1.06-.28h-.76V17.42Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forward_30.propTypes = iconPropTypes;
}
const Forward_5 = /*#__PURE__*/React.forwardRef(function Forward_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h4v5l6-6L20,1V6H16A12,12,0,1,0,28,18Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Forward_5.propTypes = iconPropTypes;
}
const Fragile = /*#__PURE__*/React.forwardRef(function Fragile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M23,12V6H21v6a5,5,0,0,1-10,0V4h5.5859L14.293,6.293a.9994.9994,0,0,0,0,1.414L15.5859,9,13.293,11.293l1.414,1.414,3-3a.9994.9994,0,0,0,0-1.414L16.4141,7,19.707,3.707A1,1,0,0,0,19,2H10A1,1,0,0,0,9,3v9a7.0053,7.0053,0,0,0,6,6.92V28H10v2H22V28H17V18.92A7.0053,7.0053,0,0,0,23,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fragile.propTypes = iconPropTypes;
}
const Fragments = /*#__PURE__*/React.forwardRef(function Fragments({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-2.4146,0-4.4348-1.7206-4.8997-4h-5.1003c-1.1028,0-2-.8972-2-2v-5h1c1.6543,0,3-1.3458,3-3s-1.3457-3-3-3h-1v-5c0-1.1028.8972-2,2-2h5.1003c.4648-2.2794,2.4851-4,4.8997-4s4.4348,1.7206,4.8997,4h5.1003c1.1028,0,2,.8972,2,2v5h-1c-1.6543,0-3,1.3458-3,3s1.3457,3,3,3h1v5c0,1.1028-.8972,2-2,2h-5.1003c-.4648,2.2794-2.4851,4-4.8997,4ZM6,20.8995v3.1005h7v1c0,1.6542,1.3457,3,3,3s3-1.3458,3-3v-1h7v-3.1005c-2.2793-.4646-4-2.485-4-4.8995s1.7207-4.4349,4-4.8995v-3.1005h-7v-1c0-1.6542-1.3457-3-3-3s-3,1.3458-3,3v1h-7v3.1005c2.2793.4646,4,2.485,4,4.8995s-1.7207,4.4349-4,4.8995Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Fragments.propTypes = iconPropTypes;
}
const Friendship = /*#__PURE__*/React.forwardRef(function Friendship({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10H7a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H12V28H8V19H6V13a1.0009,1.0009,0,0,1,1-1H25a1.0009,1.0009,0,0,1,1,1v6H24v9H20V16H18V28a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,25,10Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,10,9Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,10,3Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,22,9Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,22,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Friendship.propTypes = iconPropTypes;
}
const FruitBowl = /*#__PURE__*/React.forwardRef(function FruitBowl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15a6.0025,6.0025,0,0,0-3.1067-5.2529A3.9792,3.9792,0,0,0,24,7H22a2.0023,2.0023,0,0,1-2,2,6.004,6.004,0,0,0-5.9946,5.8921A7.0005,7.0005,0,0,1,12,10,3.9961,3.9961,0,0,0,9,6.1419V4H7V6.1419A3.9961,3.9961,0,0,0,4,10v5H2v1a14,14,0,0,0,28,0V15Zm-6-4a4.0045,4.0045,0,0,1,4,4H16A4.0045,4.0045,0,0,1,20,11ZM6,10a2,2,0,1,1,4,0,8.991,8.991,0,0,0,1.5322,5H6ZM16,28A12.0166,12.0166,0,0,1,4.0415,17h23.917A12.0166,12.0166,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FruitBowl.propTypes = iconPropTypes;
}
const Function = /*#__PURE__*/React.forwardRef(function Function({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262,29.5256,19.11,27.5935A12.0035,12.0035,0,0,0,25.2312,8.3323l1.5376-1.2788a14.0033,14.0033,0,0,1-7.1426,22.4721Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M10,29H8V25.18l.8037-.1607C10.2617,24.728,12,23.6206,12,20V18.6182l-4-2V14.3818l4-2V12c0-5.4673,3.9253-9,10-9h2V6.82l-.8037.1607C21.7383,7.272,20,8.3794,20,12v.3818l4,2v2.2364l-4,2V20C20,25.4673,16.0747,29,10,29Zm0-2c4.9346,0,8-2.6821,8-7V17.3818L21.7642,15.5,18,13.6182V12c0-4.5781,2.3853-6.1924,4-6.76V5c-4.9346,0-8,2.6821-8,7v1.6182L10.2358,15.5,14,17.3818V20c0,4.5781-2.3853,6.1924-4,6.76Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2312,24.9465A14.0032,14.0032,0,0,1,12.3779,2.4734l.5161,1.9321A12.0035,12.0035,0,0,0,6.7688,23.6677Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Function.propTypes = iconPropTypes;
}
const Function_2 = /*#__PURE__*/React.forwardRef(function Function_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3,13l-1.3,13.2c-.1.9926-.9,1.8-1.9,1.8h-5.1v-2h5l1.3-13h-4.3v-2h4.5l.5-5.2c.0916-1.0019,1-1.8,2-1.8h5v2h-5l-.5,5h4.5v2h-4.7ZM16,19v7c0,1.1.9,2,2,2h2v-2h-2v-7h2v-2h-2c-1.1,0-2,.9-2,2ZM26,17h-2v2h2v7h-2v2h2c1.1,0,2-.9,2-2v-7c0-1.1-.9-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Function_2.propTypes = iconPropTypes;
}
const FunctionMath = /*#__PURE__*/React.forwardRef(function FunctionMath({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18L24 18 22 21.897 20 18 18 18 20.905 23 18 28 20 28 22 24.201 24 28 26 28 23.098 23 26 18z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M19,6V4H13.9133a1.9906,1.9906,0,0,0-1.9919,1.8188L11.2686,13H7v2h4.0867l-1,11H5v2h5.0867a1.9906,1.9906,0,0,0,1.9919-1.8188L13.0952,15H18V13H13.2769l.6364-7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  FunctionMath.propTypes = iconPropTypes;
}
const WatsonHealthFusionBlender = /*#__PURE__*/React.forwardRef(function WatsonHealthFusionBlender({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17V4h3V2H12V4h3v8H12a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h3v8H12v2h8V28H17V20h3a2,2,0,0,0,2-2V14A2,2,0,0,0,20,12Zm-8,6V14h8v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthFusionBlender.propTypes = iconPropTypes;
}
const GameConsole = /*#__PURE__*/React.forwardRef(function GameConsole({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,26a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,19l2.33-8.84A5.54,5.54,0,0,1,7.11,6.73a5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,9h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.57,5.57,0,0,1,2.59,3.41L29.81,19a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,21H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,26ZM9.83,8a3.49,3.49,0,0,0-1.72.46,3.6,3.6,0,0,0-1.66,2.19L4.12,19.49A3.6,3.6,0,0,0,6.6,23.88a3.43,3.43,0,0,0,2.62-.34,3.54,3.54,0,0,0,1.66-2.19L11.5,19h9l.61,2.35a3.58,3.58,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.55,3.55,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,8Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a2,2,0,1,1,2-2A2,2,0,0,1,10,16Zm0-2Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "14",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "14",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GameConsole.propTypes = iconPropTypes;
}
const GameWireless = /*#__PURE__*/React.forwardRef(function GameWireless({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51,30a5.48,5.48,0,0,1-1.44-.19A5.6,5.6,0,0,1,2.19,23l2.33-8.84a5.54,5.54,0,0,1,2.59-3.41,5.43,5.43,0,0,1,4.15-.54A5.52,5.52,0,0,1,14.7,13h2.6a5.49,5.49,0,0,1,3.44-2.81,5.43,5.43,0,0,1,4.15.54,5.55,5.55,0,0,1,2.59,3.41L29.81,23a5.6,5.6,0,0,1-3.89,6.83,5.43,5.43,0,0,1-4.15-.54,5.54,5.54,0,0,1-2.59-3.41L19,25H13l-.23.86a5.54,5.54,0,0,1-2.59,3.41A5.46,5.46,0,0,1,7.51,30ZM9.83,12a3.49,3.49,0,0,0-1.72.46,3.58,3.58,0,0,0-1.66,2.19L4.12,23.49A3.6,3.6,0,0,0,6.6,27.88a3.43,3.43,0,0,0,2.62-.34,3.57,3.57,0,0,0,1.66-2.19L11.5,23h9l.61,2.35a3.6,3.6,0,0,0,1.66,2.19,3.46,3.46,0,0,0,2.63.34,3.58,3.58,0,0,0,2.47-4.39l-2.33-8.84a3.53,3.53,0,0,0-1.65-2.19,3.46,3.46,0,0,0-2.63-.34,3.55,3.55,0,0,0-2.37,2.22l-.24.66h-5.3l-.24-.66a3.56,3.56,0,0,0-2.38-2.22A3.48,3.48,0,0,0,9.83,12Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20a2,2,0,1,1,2-2A2,2,0,0,1,10,20Zm0-2Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "20",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "18",
    r: "1"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "18",
    r: "1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75,9l-1.5-1.33a5,5,0,0,1,7.5,0L18.25,9a3,3,0,0,0-4.5,0Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25,6.37a7,7,0,0,0-10.5,0L9.25,5.05a9,9,0,0,1,13.5,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GameWireless.propTypes = iconPropTypes;
}
const Gamification = /*#__PURE__*/React.forwardRef(function Gamification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23h-.1315l.9635-1.4453A1.0008,1.0008,0,0,0,24,21V12.0005c0-9.8858-7.92-10-8-10A1,1,0,0,0,15,3l-.0005,2H14a.9956.9956,0,0,0-.581.1865l-7,5a1,1,0,0,0-.3676,1.13l1,3a.9976.9976,0,0,0,1.09.6733l4.87-.6958L9.1519,20.47a1,1,0,0,0,.0161,1.085L10.1315,23H10a3.0033,3.0033,0,0,0-3,3v4H26V26A3.0033,3.0033,0,0,0,23,23Zm-7.1519-9.47a1,1,0,0,0-.99-1.52l-6.1738.8819-.5025-1.5078L14.32,7.0005H15.999a1,1,0,0,0,1-.9995L17,4.1289C18.5013,4.4636,21.2167,5.67,21.86,10H19v2h3v2H19v2h3v2H19v2h3v.6973L20.4648,23h-7.93L11.19,20.9824ZM24,28H9V26a1.0009,1.0009,0,0,1,1-1H23a1.0006,1.0006,0,0,1,1,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gamification.propTypes = iconPropTypes;
}
const GasStation = /*#__PURE__*/React.forwardRef(function GasStation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H15V12H8z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4142,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5644,3.5644,0,0,0,2.7654,3.5251A3.5062,3.5062,0,0,0,29,24.5V9.4144A2,2,0,0,0,28.4142,8ZM17,26H6V6H17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GasStation.propTypes = iconPropTypes;
}
const GasStationFilled = /*#__PURE__*/React.forwardRef(function GasStationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H15V12H8z",
    "data-icon-path": "inner-path"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4143,8l-5-5L22,4.4141l3,3V12a2.0023,2.0023,0,0,0,2,2V24.5a1.5,1.5,0,0,1-3,0V16a1,1,0,0,0-1-1H19V5a1,1,0,0,0-1-1H5A1,1,0,0,0,4,5V26H2v2H21V26H19V17h3v7.4a3.5645,3.5645,0,0,0,2.7654,3.5249A3.506,3.506,0,0,0,29,24.5V9.4146A2,2,0,0,0,28.4143,8ZM15,12H8V10h7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GasStationFilled.propTypes = iconPropTypes;
}
const Gateway = /*#__PURE__*/React.forwardRef(function Gateway({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M31,16a1.9857,1.9857,0,0,0-.5859-1.4141L24.6211,8.793,27.489,5.9253a2,2,0,1,0-1.414-1.4141L23.207,7.3789l-5.7929-5.793a1.9995,1.9995,0,0,0-2.8282,0L8.793,7.3789,5.925,4.5112A2,2,0,1,0,4.511,5.9253L7.3789,8.793l-5.793,5.7929a1.9995,1.9995,0,0,0,0,2.8282l5.793,5.7929L4.511,26.0747a2,2,0,1,0,1.414,1.4141l2.868-2.8677,5.7929,5.793a1.9995,1.9995,0,0,0,2.8282,0l5.7929-5.793,2.868,2.8677a2,2,0,1,0,1.414-1.4141L24.6211,23.207l5.793-5.7929A1.9866,1.9866,0,0,0,31,16Zm-7.793,5.793L20.4141,19,19,20.4141l2.793,2.7929L16,29l-5.793-5.793L13,20.4141,11.5859,19,8.793,21.793,3,16l5.7925-5.7935L11.5859,13,13,11.5859,10.2065,8.7925,16,3l5.7935,5.7925L19,11.5859,20.4141,13l2.7934-2.7935L29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gateway.propTypes = iconPropTypes;
}
const GatewayApi = /*#__PURE__*/React.forwardRef(function GatewayApi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M17,18.1841V13.8159a3.0007,3.0007,0,1,0-2,0v4.3687a3,3,0,1,0,2,0ZM16,10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Zm0,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,22Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayApi.propTypes = iconPropTypes;
}
const GatewayMail = /*#__PURE__*/React.forwardRef(function GatewayMail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8779,12.1218a.4186.4186,0,0,0-.437-.0971l-9.1666,3.3335a.4167.4167,0,0,0-.0122.7786l4.0006,1.6,1.6,4.0007A.4168.4168,0,0,0,16.25,22h.0067a.4169.4169,0,0,0,.3849-.2743l3.3333-9.1669A.4165.4165,0,0,0,19.8779,12.1218Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayMail.propTypes = iconPropTypes;
}
const GatewayPublic = /*#__PURE__*/React.forwardRef(function GatewayPublic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14H14V12a2,2,0,0,1,4,0h2a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A2.0023,2.0023,0,0,0,19,14Zm0,7H13V16h6Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayPublic.propTypes = iconPropTypes;
}
const GatewaySecurity = /*#__PURE__*/React.forwardRef(function GatewaySecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11v6.4678a5.0216,5.0216,0,0,0,2.8613,4.52L16,23l2.1387-1.0127A5.0216,5.0216,0,0,0,21,17.4678V11Zm8,6.4678a3.012,3.012,0,0,1-1.7168,2.7109L16,20.7861l-1.2832-.6074A3.012,3.012,0,0,1,13,17.4678V13h6Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewaySecurity.propTypes = iconPropTypes;
}
const GatewayUserAccess = /*#__PURE__*/React.forwardRef(function GatewayUserAccess({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H19V20a1.0011,1.0011,0,0,0-1-1H14a1.0011,1.0011,0,0,0-1,1v2H11V20a3.0033,3.0033,0,0,1,3-3h4a3.0033,3.0033,0,0,1,3,3Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a3.5,3.5,0,1,1,3.5-3.5A3.5041,3.5041,0,0,1,16,16Zm0-5a1.5,1.5,0,1,0,1.5,1.5A1.5017,1.5017,0,0,0,16,11Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayUserAccess.propTypes = iconPropTypes;
}
const GatewayVpn = /*#__PURE__*/React.forwardRef(function GatewayVpn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14.2783V12a4,4,0,0,0-8,0v2.2783A1.9929,1.9929,0,0,0,11,16v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V16A1.9929,1.9929,0,0,0,20,14.2783ZM16,10a2.0023,2.0023,0,0,1,2,2v2H14V12A2.0023,2.0023,0,0,1,16,10Zm3,11H13V16h6Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GatewayVpn.propTypes = iconPropTypes;
}
const Gears = /*#__PURE__*/React.forwardRef(function Gears({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,21.9847c0-.4595-.0568-.9053-.155-1.3354l2.155-.8273-.7167-1.8671-2.2063.8469c-.4529-.7197-1.0501-1.3392-1.7568-1.8106l.9695-2.1777-1.8271-.8135-.9706,2.1801c-.478-.123-.9761-.1954-1.492-.1954s-1.014.0724-1.492.1954l-.9706-2.1801-1.8271.8135.9695,2.1777c-.7067.4714-1.3039,1.0909-1.7568,1.8106l-2.2063-.8469-.7167,1.8671,2.155.8273c-.0983.4302-.155.8759-.155,1.3354,0,.4396.0507.8672.1408,1.2802l-2.1408.9531.8135,1.8271,2.08-.9261c.442.7173,1.0259,1.3374,1.7191,1.8134l-.9023,2.3508,1.8671.7167.856-2.2299c.5004.1357,1.0239.2146,1.5666.2146s1.0662-.0789,1.5666-.2146l.856,2.2299,1.8671-.7167-.9023-2.3508c.6932-.476,1.2772-1.0961,1.7191-1.8134l2.08.9261.8135-1.8271-2.1408-.9531c.0901-.413.1408-.8406.1408-1.2802Zm-6,4c-2.2061,0-4-1.7944-4-4s1.7939-4,4-4,4,1.7944,4,4-1.7939,4-4,4Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13.471,14.8852l1.4788,1.4788,1.4142-1.4142-1.4788-1.4787c.5146-.7222.871-1.5616,1.0245-2.471h2.0903v-2h-2.0903c-.1535-.9094-.5098-1.7488-1.0245-2.471l1.4788-1.4788-1.4142-1.4142-1.4788,1.4788c-.7222-.5146-1.5616-.871-2.471-1.0245v-2.0903h-2v2.0903c-.9094.1535-1.7488.5099-2.471,1.0245l-1.4788-1.4788-1.4142,1.4142,1.4788,1.4788c-.5146.7222-.871,1.5616-1.0245,2.471H2v2h2.0903c.1535.9094.5098,1.7488,1.0245,2.471l-1.4788,1.4787,1.4142,1.4142,1.4788-1.4788c.7222.5146,1.5616.871,2.471,1.0245v2.0903h2v-2.0903c.9094-.1535,1.7488-.5098,2.471-1.0245Zm-7.471-4.8852c0-2.2056,1.7939-4,4-4s4,1.7944,4,4-1.7939,4-4,4-4-1.7944-4-4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gears.propTypes = iconPropTypes;
}
const Gem = /*#__PURE__*/React.forwardRef(function Gem({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,16,29.5269,30.2842,13.0454ZM27,12H21.5543l-3.75-6H22.5ZM10.3021,14l3.7536,10.23L5.19,14Zm2.13,0H19.568l-3.569,9.7212Zm.3725-2L16,6.8867,19.1957,12Zm8.8935,2H26.81L17.9427,24.2314ZM9.5,6h4.6957l-3.75,6H5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gem.propTypes = iconPropTypes;
}
const GemReference = /*#__PURE__*/React.forwardRef(function GemReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H8.5L1.7158,13.0454,6.01,18l1.5114-1.31L5.19,14h5.2554L16,22.8867,21.5544,14H26.81L15.8125,26.6919,17.3242,28l12.96-14.9546ZM5,12,9.5,6h4.6958l-3.75,6ZM16,6.8867,19.1958,12H12.8042Zm0,12.2266L12.8044,14h6.3912ZM21.5542,12l-3.75-6H22.5L27,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GemReference.propTypes = iconPropTypes;
}
const GenderFemale = /*#__PURE__*/React.forwardRef(function GenderFemale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19.9307a8,8,0,1,0-2,0V22H10v2h5v4h2V24h5V22H17ZM10,12a6,6,0,1,1,6,6A6.0066,6.0066,0,0,1,10,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GenderFemale.propTypes = iconPropTypes;
}
const GenderMale = /*#__PURE__*/React.forwardRef(function GenderMale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M18,4V6h6.5859l-7.6884,7.6885a8.028,8.028,0,1,0,1.414,1.414L26,7.4141V14h2V4ZM12,26a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,12,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GenderMale.propTypes = iconPropTypes;
}
const GeneratePdf = /*#__PURE__*/React.forwardRef(function GeneratePdf({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24v4H8V24H6v4H6a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2h0V24Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21L19.586 19.586 17 22.172 17 14 15 14 15 22.172 12.414 19.586 11 21 16 26 21 21z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4L28 2 22 2 22 12 24 12 24 8 27 8 27 6 24 6 24 4 28 4z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12H13V2h4a3.0033,3.0033,0,0,1,3,3V9A3.0033,3.0033,0,0,1,17,12Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V5a1.0011,1.0011,0,0,0-1-1H15Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9,2H4V12H6V9H9a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,9,2ZM6,7V4H9l.001,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GeneratePdf.propTypes = iconPropTypes;
}
const Gif = /*#__PURE__*/React.forwardRef(function Gif({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M2,12v8a3,3,0,0,0,3,3h5V15H6v2H8v4H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h5V9H5A3,3,0,0,0,2,12Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9L12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gif.propTypes = iconPropTypes;
}
const Gift = /*#__PURE__*/React.forwardRef(function Gift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gift.propTypes = iconPropTypes;
}
const GlobalLoanAndTrial = /*#__PURE__*/React.forwardRef(function GlobalLoanAndTrial({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m15,22l-1.4099,1.4102,2.5798,2.5898H4V8h-2v18c0,1.1025.8972,2,2,2h12.1699l-2.5798,2.5898,1.4099,1.4102,5-5-5-5Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m24,20H8c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h16c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-16-6v4h16v-4H8Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m28,4h-12.1699l2.5801-2.5898L17,0l-5,5,5,5,1.4102-1.4102-2.5801-2.5898h12.1699v18h2V6c0-1.1025-.8972-2-2-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GlobalLoanAndTrial.propTypes = iconPropTypes;
}
const Globe = /*#__PURE__*/React.forwardRef(function Globe({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4a7,7,0,1,1-7,7,7,7,0,0,1,7-7m0-2a9,9,0,1,0,9,9A9,9,0,0,0,14,2Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a13.9563,13.9563,0,0,0-4.1051-9.8949L22.4813,2.5187A11.9944,11.9944,0,0,1,5.5568,19.5194l-.0381-.0381L4.1051,20.8949A13.9563,13.9563,0,0,0,14,25v3H10v2H20V28H16V24.84A14.0094,14.0094,0,0,0,28,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Globe.propTypes = iconPropTypes;
}
const Gradient = /*#__PURE__*/React.forwardRef(function Gradient({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0023,2.0023,0,0,0,4,6V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM22,26V22H18v4H14V22H10V18h4V14H10V10h4V6h4v4h4V6h4V26Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H18V14H14z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V22H14z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H22V18H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gradient.propTypes = iconPropTypes;
}
const GraphicalDataFlow = /*#__PURE__*/React.forwardRef(function GraphicalDataFlow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H22a2.0023,2.0023,0,0,1-2-2V22a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,30Zm-6-8h-.0012L22,28h6V22Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H12a3.0033,3.0033,0,0,1-3-3V19h2v4a1.001,1.001,0,0,0,1,1h6Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H24V15a1.001,1.001,0,0,0-1-1H18V12h5a3.0033,3.0033,0,0,1,3,3Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M15,18a.9986.9986,0,0,1-.4971-.1323L10,15.2886,5.4968,17.8677a1,1,0,0,1-1.4712-1.0938l1.0618-4.572L2.269,9.1824a1,1,0,0,1,.5662-1.6687l4.2-.7019L9.1006,2.5627a1,1,0,0,1,1.7881-.0214l2.2046,4.271,4.0764.7021a1,1,0,0,1,.5613,1.668l-2.8184,3.02,1.0613,4.5718A1,1,0,0,1,15,18Zm-5-5s.343.18.4971.2686l3.01,1.7241-.7837-3.3763,2.282-2.4453-3.2331-.5569-1.7456-3.382L8.3829,8.6144l-3.3809.565,2.2745,2.437-.7841,3.3763,3.0105-1.7241C9.657,13.18,10,13,10,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GraphicalDataFlow.propTypes = iconPropTypes;
}
const Grid = /*#__PURE__*/React.forwardRef(function Grid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6A2,2,0,0,0,12,4Zm0,8H6V6h6Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,8H20V6h6Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M12,18H6a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V20A2,2,0,0,0,12,18Zm0,8H6V20h6Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V20A2,2,0,0,0,26,18Zm0,8H20V20h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Grid.propTypes = iconPropTypes;
}
const Group = /*#__PURE__*/React.forwardRef(function Group({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M31,30H29V27a3,3,0,0,0-3-3H22a3,3,0,0,0-3,3v3H17V27a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M24,12a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,24,10Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M15,22H13V19a3,3,0,0,0-3-3H6a3,3,0,0,0-3,3v3H1V19a5,5,0,0,1,5-5h4a5,5,0,0,1,5,5Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8,4A3,3,0,1,1,5,7,3,3,0,0,1,8,4M8,2a5,5,0,1,0,5,5A5,5,0,0,0,8,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Group.propTypes = iconPropTypes;
}
const GroupAccess = /*#__PURE__*/React.forwardRef(function GroupAccess({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8,19H6V17a3.0033,3.0033,0,0,1,3-3h5v2H9a1.0011,1.0011,0,0,0-1,1Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,12,13Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,12,7Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,20,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,20,14Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H24V24a1.0011,1.0011,0,0,0-1-1H17a1.0011,1.0011,0,0,0-1,1v2H14V24a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H8V4H4V28H8Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24V28h4V4H24V2h4a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupAccess.propTypes = iconPropTypes;
}
const GroupAccount = /*#__PURE__*/React.forwardRef(function GroupAccount({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M17,11H11a3,3,0,0,0-3,3v4h2V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v1h2V14A3,3,0,0,0,17,11Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6a4,4,0,1,0,4-4A4,4,0,0,0,10,6Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,16,6Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M22,27H16a2.0021,2.0021,0,0,1-2-2V19a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,22,27Zm-6-8v6h6V19Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H8V4H4V28H8Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24V28h4V4H24V2h4a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupAccount.propTypes = iconPropTypes;
}
const GroupPresentation = /*#__PURE__*/React.forwardRef(function GroupPresentation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H8V27H4v3H2V27a2.0023,2.0023,0,0,1,2-2H8a2.0023,2.0023,0,0,1,2,2Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V27H24v3H22V27a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H18V27H14v3H12V27a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "22",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "22",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "18",
    r: "2"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,26,14ZM6,4v8H26V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupPresentation.propTypes = iconPropTypes;
}
const GroupResource = /*#__PURE__*/React.forwardRef(function GroupResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24H10a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2H22a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,22,24ZM10,10V22H22V10Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H8V4H4V28H8Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24V28h4V4H24V2h4a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupResource.propTypes = iconPropTypes;
}
const GroupSecurity = /*#__PURE__*/React.forwardRef(function GroupSecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M11,21H9V19a3.0033,3.0033,0,0,1,3-3h6v2H12a1.0011,1.0011,0,0,0-1,1Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M15,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,15,15Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,15,9Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M24,22a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,22Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,24,16Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H28V26a1.0011,1.0011,0,0,0-1-1H21a1.0011,1.0011,0,0,0-1,1v2H18V26a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupSecurity.propTypes = iconPropTypes;
}
const GroupObjects = /*#__PURE__*/React.forwardRef(function GroupObjects({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M19,13V9H9V19h4v4H23V13Zm-8-2h6v6H11ZM21,21H15V19h4V15h2Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupObjects.propTypes = iconPropTypes;
}
const GroupObjectsNew = /*#__PURE__*/React.forwardRef(function GroupObjectsNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10L15 10 15 15 10 15 10 17 15 17 15 22 17 22 17 17 22 17 22 15 17 15 17 10z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupObjectsNew.propTypes = iconPropTypes;
}
const GroupObjectsSave = /*#__PURE__*/React.forwardRef(function GroupObjectsSave({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.18L10.41 14.59 9 16 14 21 23 12 21.59 10.581 14 18.18z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V2H24V4H8V2H2V8H4V24H2v6H8V28H24v2h6V24H28V8ZM26,4h2V6H26ZM4,4H6V6H4ZM6,28H4V26H6Zm22,0H26V26h2Zm-2-4H24v2H8V24H6V8H8V6H24V8h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GroupObjectsSave.propTypes = iconPropTypes;
}
const Growth = /*#__PURE__*/React.forwardRef(function Growth({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8v2h6.5859L18,18.5859,13.707,14.293a.9994.9994,0,0,0-1.414,0L2,24.5859,3.4141,26,13,16.4141l4.293,4.2929a.9994.9994,0,0,0,1.414,0L28,11.4141V18h2V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Growth.propTypes = iconPropTypes;
}
const Gui = /*#__PURE__*/React.forwardRef(function Gui({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "8",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "8",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4Zm0,2v4H4V6ZM4,12h6V26H4Zm8,14V12H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Gui.propTypes = iconPropTypes;
}
const GuiManagement = /*#__PURE__*/React.forwardRef(function GuiManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.002,2.002,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H14V26H4V12H28v3h2V6A2.0023,2.0023,0,0,0,28,4Zm0,6H4V6H28Z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "8",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "8",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "8",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  GuiManagement.propTypes = iconPropTypes;
}
const QH = /*#__PURE__*/React.forwardRef(function QH({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QH.propTypes = iconPropTypes;
}
const Hail = /*#__PURE__*/React.forwardRef(function Hail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "25.5",
    r: "1.5"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "4.5",
    cy: "29.5",
    r: "1.5"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.499",
    cy: "29.5",
    r: "1.5"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496L14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hail.propTypes = iconPropTypes;
}
const WatsonHealthHangingProtocol = /*#__PURE__*/React.forwardRef(function WatsonHealthHangingProtocol({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37,20.52,17,15.41V13.86A4,4,0,1,0,12,10h2a2,2,0,1,1,4,.34A2.08,2.08,0,0,1,15.89,12h0a.89.89,0,0,0-.89.89v2.52L5.63,20.52A3.1,3.1,0,0,0,4.25,22a2.83,2.83,0,0,0,2.56,4H25.19a2.83,2.83,0,0,0,2.56-4A3.1,3.1,0,0,0,26.37,20.52ZM25.19,24H6.81A.81.81,0,0,1,6,23.19a1,1,0,0,1,.52-.88L16,17.14l9.48,5.17a1,1,0,0,1,.52.88A.81.81,0,0,1,25.19,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHangingProtocol.propTypes = iconPropTypes;
}
const Harbor = /*#__PURE__*/React.forwardRef(function Harbor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M27,17A11.0109,11.0109,0,0,1,17,27.9492V14h6V12H17V9.8579a4,4,0,1,0-2,0V12H9v2h6V27.9492A11.0109,11.0109,0,0,1,5,17H3a13,13,0,0,0,26,0ZM14,6a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,14,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Harbor.propTypes = iconPropTypes;
}
const HardwareSecurityModule = /*#__PURE__*/React.forwardRef(function HardwareSecurityModule({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "7.5",
    r: "1.5"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4143,20H9V14.5857l6.03-6.03A5.3518,5.3518,0,0,1,15,8a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM11,18h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,21,12a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L11,15.4143Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H19v2h9v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HardwareSecurityModule.propTypes = iconPropTypes;
}
const Hashtag = /*#__PURE__*/React.forwardRef(function Hashtag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hashtag.propTypes = iconPropTypes;
}
const Haze = /*#__PURE__*/React.forwardRef(function Haze({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H3a1,1,0,0,1,0-2H19a1,1,0,0,1,0,2Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M15,20H3a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.5H28.5V25.5H24.5z",
    transform: "rotate(45 26.5 24.5)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H32V17H28z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5H28.5V8.5H24.5z",
    transform: "rotate(-45 26.5 7.5)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H11.5V8.5H7.5z",
    transform: "rotate(-135 9.5 7.5)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a8.0092,8.0092,0,0,0-8,8h2a6,6,0,1,1,6,6H7a1,1,0,0,0,0,2H18A8,8,0,0,0,18,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Haze.propTypes = iconPropTypes;
}
const HazeNight = /*#__PURE__*/React.forwardRef(function HazeNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M29,22H13a1,1,0,0,0,0,2h9.6772a11.0991,11.0991,0,0,1-7.5561,2.9976c-.1384,0-.2783.0048-.4177,0a11.0945,11.0945,0,0,1-3.201-21.584,15.1528,15.1528,0,0,0-.0488,6.5869h2.0457a13.15,13.15,0,0,1,.39-7.6206A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0A13.04,13.04,0,0,0,25.3779,24H29a1,1,0,0,0,0-2Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20H17a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H13a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HazeNight.propTypes = iconPropTypes;
}
const Hd = /*#__PURE__*/React.forwardRef(function Hd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M22,11H18V21h4a3,3,0,0,0,3-3V14A3,3,0,0,0,22,11Zm1,7a1,1,0,0,1-1,1H20V13h2a1,1,0,0,1,1,1Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13 15 10 15 10 11 8 11 8 21 10 21 10 17 13 17 13 21 15 21 15 11 13 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hd.propTypes = iconPropTypes;
}
const HdFilled = /*#__PURE__*/React.forwardRef(function HdFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13H20v6h2a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,21H13V17H10v4H8V11h2v4h3V11h2Zm10-3a3,3,0,0,1-3,3H18V11h4a3,3,0,0,1,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HdFilled.propTypes = iconPropTypes;
}
const Hdr = /*#__PURE__*/React.forwardRef(function Hdr({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15V11a2,2,0,0,0-2-2H22V23h2V17h1.48l2.34,6H30l-2.33-6H28A2,2,0,0,0,30,15Zm-6-4h4v4H24Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,16,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H14Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hdr.propTypes = iconPropTypes;
}
const Headphones = /*#__PURE__*/React.forwardRef(function Headphones({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16V15A9,9,0,0,0,7,15v1A5,5,0,0,0,7,26H9V15a7,7,0,0,1,14,0V26h2a5,5,0,0,0,0-10ZM4,21a3,3,0,0,1,3-3v6A3,3,0,0,1,4,21Zm21,3V18a3,3,0,0,1,0,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Headphones.propTypes = iconPropTypes;
}
const Headset = /*#__PURE__*/React.forwardRef(function Headset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Headset.propTypes = iconPropTypes;
}
const HealthCross = /*#__PURE__*/React.forwardRef(function HealthCross({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M19,28H13a2.0023,2.0023,0,0,1-2-2V21H6a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h5V6a2.002,2.002,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v5h5a2.0023,2.0023,0,0,1,2,2v6a2.0027,2.0027,0,0,1-2,2H21v5A2.0027,2.0027,0,0,1,19,28ZM6,13v6h7v7h6V19h7V13H19V6H13v7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HealthCross.propTypes = iconPropTypes;
}
const Hearing = /*#__PURE__*/React.forwardRef(function Hearing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30V28A10.0114,10.0114,0,0,0,28,18h2A12.0134,12.0134,0,0,1,18,30Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26V24a6.0066,6.0066,0,0,0,6-6h2A8.0092,8.0092,0,0,1,18,26Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M18,22V20a2.0023,2.0023,0,0,0,2-2h2A4.0042,4.0042,0,0,1,18,22Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M10,2a9.01,9.01,0,0,0-9,9H3a7,7,0,0,1,14,0,7.09,7.09,0,0,1-3.501,6.1348L13,17.4229v3.0732a2.9354,2.9354,0,0,1-.9009,2.1514,4.1824,4.1824,0,0,1-4.6318,1.03A4.0918,4.0918,0,0,1,5,20H3a6.1156,6.1156,0,0,0,3.6694,5.5117,5.7822,5.7822,0,0,0,2.3145.4863A6.5854,6.5854,0,0,0,13.4624,24.11,4.94,4.94,0,0,0,15,20.4961V18.5537A9.1077,9.1077,0,0,0,19,11,9.01,9.01,0,0,0,10,2Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28,8.0825A3.0061,3.0061,0,0,1,13,11h2a4.9786,4.9786,0,0,0-1.8843-3.9111A5.0414,5.0414,0,0,0,8.835,6.1323,4.95,4.95,0,0,0,5.1323,9.835,5.0318,5.0318,0,0,0,7.436,15.2935,3.0777,3.0777,0,0,1,9,17.9229V20h2V17.9229a5.0608,5.0608,0,0,0-2.5371-4.3458A3.0016,3.0016,0,0,1,9.28,8.0825Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hearing.propTypes = iconPropTypes;
}
const HeatMap = /*#__PURE__*/React.forwardRef(function HeatMap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V20H20z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V18H28z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H16V8H14z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22H12V16a2.0023,2.0023,0,0,0-2-2H4a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h6v4a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V24A2.0023,2.0023,0,0,0,16,22ZM4,22V16h6v6Zm8,6V24h4v4Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24a2.0021,2.0021,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,28,30Zm-4-6v4h4V24Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H22a2.0023,2.0023,0,0,0-2,2v6H18a2.0023,2.0023,0,0,0-2,2v2a2.0023,2.0023,0,0,0,2,2h2a2.0023,2.0023,0,0,0,2-2V12h6a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM18,14V12h2v2Zm4-4V4h6v6Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H4A2.0021,2.0021,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H8a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,8,10ZM4,4V8H8V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMap.propTypes = iconPropTypes;
}
const HeatMap_02 = /*#__PURE__*/React.forwardRef(function HeatMap_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "20",
    r: "2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "12",
    r: "2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "19",
    r: "1"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,30A3.5,3.5,0,1,1,30,26.5,3.5041,3.5041,0,0,1,26.5,30Zm0-5A1.5,1.5,0,1,0,28,26.5,1.5017,1.5017,0,0,0,26.5,25Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M14,30a3.958,3.958,0,0,1-2.126-.6211,6.9977,6.9977,0,1,1,4.1109-6.8384A3.9916,3.9916,0,0,1,14,30Zm-1.8843-3.0278.5391.4946a1.9915,1.9915,0,1,0,2.0039-3.343l-.6909-.2432.03-.8467a5.0085,5.0085,0,1,0-2.5166,4.3023Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16a6.0067,6.0067,0,0,1-6-6,5.3246,5.3246,0,0,1,.0269-.5327A3.9564,3.9564,0,0,1,16,6a4.0045,4.0045,0,0,1,4-4,3.9564,3.9564,0,0,1,3.4673,2.0271C23.6484,4.009,23.8252,4,24,4a6,6,0,0,1,0,12ZM20,4a2.0021,2.0021,0,0,0-2,2,1.9805,1.9805,0,0,0,1.43,1.9023l.9018.2706-.2153.9162A3.9938,3.9938,0,1,0,24,6a4.0064,4.0064,0,0,0-.9121.1162l-.9155.2141-.27-.9006A1.9807,1.9807,0,0,0,20,4Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,11A4.5,4.5,0,1,1,11,6.5,4.5051,4.5051,0,0,1,6.5,11Zm0-7A2.5,2.5,0,1,0,9,6.5,2.503,2.503,0,0,0,6.5,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMap_02.propTypes = iconPropTypes;
}
const HeatMap_03 = /*#__PURE__*/React.forwardRef(function HeatMap_03({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2.0023,2.0023,0,0,0,3,5V27a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V5A2.0023,2.0023,0,0,0,27,3ZM19,9H13V5h6Zm0,2v4H13V11Zm-8,0v4H5V11Zm0,6v4H5V17Zm2,0h6v4H13Zm8-2V11h6l0,4ZM5,23h6v4H5Zm16,4V23h6v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMap_03.propTypes = iconPropTypes;
}
const HeatMapStocks = /*#__PURE__*/React.forwardRef(function HeatMapStocks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM9,21H5V17H9Zm2,2h4v4H11Zm6,0h4v4H17Zm0-8V11h4v4Zm4-6H17V5h4Zm2,2h4v4H23ZM15,5V15H5V5Zm8,22V17h4V27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HeatMapStocks.propTypes = iconPropTypes;
}
const Helicopter = /*#__PURE__*/React.forwardRef(function Helicopter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8V6H8V8H18v4H4V8H2v8H4V14h6.2192l2.0533,8.2129A4.9923,4.9923,0,0,0,17.123,26H26a4.0045,4.0045,0,0,0,4-4V19.3623a2.0007,2.0007,0,0,0-.4639-1.28L25.0684,12.72A1.9968,1.9968,0,0,0,23.5317,12H20V8ZM26,24H17.123a2.9949,2.9949,0,0,1-2.91-2.2725L12.2808,14H18v6H28v2A2.0023,2.0023,0,0,1,26,24ZM23.5317,14l3.3333,4H20V14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Helicopter.propTypes = iconPropTypes;
}
const Help = /*#__PURE__*/React.forwardRef(function Help({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
      cx: "8",
      cy: "11.8",
      r: ".8"
    })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
      d: "M8.5,4H7.8C6.5,4,5.5,5,5.5,6.2c0,0,0,0,0,0v0.2h1V6.2C6.5,5.6,7.1,5,7.8,5h0.8c0.7,0,1.2,0.6,1.2,1.2S9.2,7.5,8.5,7.5h-1 v2.2h1V8.5c1.2,0,2.2-1,2.2-2.2S9.7,4,8.5,4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23.5",
    r: "1.5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M17,8H15.5A4.49,4.49,0,0,0,11,12.5V13h2v-.5A2.5,2.5,0,0,1,15.5,10H17a2.5,2.5,0,0,1,0,5H15v4.5h2V17a4.5,4.5,0,0,0,0-9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Help.propTypes = iconPropTypes;
}
const HelpFilled = /*#__PURE__*/React.forwardRef(function HelpFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,23a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Zm1.1421-7.754v2.5014h-2.25V15h2.125a2.3763,2.3763,0,0,0,0-4.7526h-1.5a2.3777,2.3777,0,0,0-2.375,2.375V13.26h-2.25v-.6377A4.6279,4.6279,0,0,1,15.5171,8h1.5a4.6238,4.6238,0,0,1,.125,9.246Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HelpFilled.propTypes = iconPropTypes;
}
const HelpDesk = /*#__PURE__*/React.forwardRef(function HelpDesk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M27,10H21a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,27,10Zm1,9H26v9H22V19H20V13a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M20,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,20,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,22,5Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16V13a3.0033,3.0033,0,0,0-3-3H5a3.0033,3.0033,0,0,0-3,3v3H0v2H16V16ZM4,13a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1v3H4Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M4,5A4,4,0,1,1,8,9,4.0042,4.0042,0,0,1,4,5ZM6,5A2,2,0,1,0,8,3,2.0023,2.0023,0,0,0,6,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HelpDesk.propTypes = iconPropTypes;
}
const HexagonOutline = /*#__PURE__*/React.forwardRef(function HexagonOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,29h-14c-.3555,0-.6846-.189-.8638-.4961L1.1362,16.5039c-.1816-.3113-.1816-.6965,0-1.0078L8.1362,3.4961c.1792-.3071.5083-.4961.8638-.4961h14c.3555,0,.6846.189.8638.4961l7,12c.1816.3113.1816.6965,0,1.0078l-7,12c-.1792.3071-.5083.4961-.8638.4961Zm-13.4258-2h12.8516l6.4165-11-6.4165-11h-12.8516l-6.4165,11,6.4165,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonOutline.propTypes = iconPropTypes;
}
const HexagonSolid = /*#__PURE__*/React.forwardRef(function HexagonSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30.8508,15.4487l-6.9641-11.9165c-.1926-.3301-.5437-.5322-.9224-.5322h-13.9287c-.3787,0-.7297.2021-.9224.5322L1.1492,15.4487c-.199.3403-.199.7622,0,1.1025l6.9641,11.9165c.1926.3301.5437.5322.9224.5322h13.9287c.3787,0,.7297-.2021.9224-.5322l6.9641-11.9165c.199-.3403.199-.7622,0-1.1025Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonSolid.propTypes = iconPropTypes;
}
const HexagonVerticalOutline = /*#__PURE__*/React.forwardRef(function HexagonVerticalOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m3,23v-14c0-.3555.189-.6846.4961-.8638L15.4961,1.1362c.3113-.1816.6965-.1816,1.0078,0l12,7c.3071.1792.4961.5083.4961.8638v14c0,.3555-.189.6846-.4961.8638l-12,7c-.3113.1816-.6965.1816-1.0078,0l-12-7c-.3071-.1792-.4961-.5083-.4961-.8638Zm2-13.4258v12.8516l11,6.4165,11-6.4165v-12.8516l-11-6.4165-11,6.4165Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonVerticalOutline.propTypes = iconPropTypes;
}
const HexagonVerticalSolid = /*#__PURE__*/React.forwardRef(function HexagonVerticalSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16.5513,30.8508l11.9165-6.9641c.3301-.1926.5322-.5437.5322-.9224v-13.9287c0-.3787-.2021-.7297-.5322-.9224L16.5513,1.1492c-.3403-.199-.7622-.199-1.1025,0L3.5322,8.1133c-.3301.1926-.5322.5437-.5322.9224v13.9287c0,.3787.2021.7297.5322.9224l11.9165,6.9641c.3403.199.7622.199,1.1025,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HexagonVerticalSolid.propTypes = iconPropTypes;
}
const QHintonPlot = /*#__PURE__*/React.forwardRef(function QHintonPlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H14V6H10z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H22V6H18z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H6V14H2z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14V14H10z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H22V14H18z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H30V14H26z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V22H2z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V22H10z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V22H18z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H30V22H26z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H6V30H2z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26H14V30H10z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H22V30H18z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26H30V30H26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QHintonPlot.propTypes = iconPropTypes;
}
const WatsonHealthHl7Attributes = /*#__PURE__*/React.forwardRef(function WatsonHealthHl7Attributes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L21 9 21 13 23 13 23 11 26.847 11 22 23 24.157 23 29 11 29 9z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L14 9 12 9 12 23 20 23 20 21 14 21z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L8 15 4 15 4 9 2 9 2 23 4 23 4 17 8 17 8 23 10 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHl7Attributes.propTypes = iconPropTypes;
}
const WatsonHealthHoleFilling = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFilling({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHoleFilling.propTypes = iconPropTypes;
}
const WatsonHealthHoleFillingCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthHoleFillingCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "19",
    r: "4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H10a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM10,10V28H28V10Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthHoleFillingCursor.propTypes = iconPropTypes;
}
const Home = /*#__PURE__*/React.forwardRef(function Home({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Home.propTypes = iconPropTypes;
}
const HorizontalView = /*#__PURE__*/React.forwardRef(function HorizontalView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,30ZM4,20H3.9985L4,28H28V20Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v8A2.0021,2.0021,0,0,1,28,14ZM4,4H3.9985L4,12H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HorizontalView.propTypes = iconPropTypes;
}
const Hospital = /*#__PURE__*/React.forwardRef(function Hospital({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10L17 10 17 6 15 6 15 10 11 10 11 12 15 12 15 16 17 16 17 12 21 12 21 10z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H26V4a2.0023,2.0023,0,0,0-2-2H8A2.0023,2.0023,0,0,0,6,4v6H4a2.0023,2.0023,0,0,0-2,2V30H30V12A2.0023,2.0023,0,0,0,28,10ZM14,28V22h4v6Zm6,0V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7H4V12H8V4H24v8h4V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hospital.propTypes = iconPropTypes;
}
const HospitalBed = /*#__PURE__*/React.forwardRef(function HospitalBed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H17a2.0023,2.0023,0,0,0-2,2v6H4V14H2V30H4V26H28v4h2V21A5.0059,5.0059,0,0,0,25,16Zm3,8H17V18h8a3.0033,3.0033,0,0,1,3,3Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,17A1.5,1.5,0,1,1,8,18.5,1.5017,1.5017,0,0,1,9.5,17m0-2A3.5,3.5,0,1,0,13,18.5,3.5,3.5,0,0,0,9.5,15Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6L17 6 17 2 15 2 15 6 11 6 11 8 15 8 15 12 17 12 17 8 21 8 21 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HospitalBed.propTypes = iconPropTypes;
}
const Hotel = /*#__PURE__*/React.forwardRef(function Hotel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,15A1.5,1.5,0,1,1,8,16.5,1.5,1.5,0,0,1,9.5,15m0-2A3.5,3.5,0,1,0,13,16.5,3.5,3.5,0,0,0,9.5,13Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14H17a2,2,0,0,0-2,2v6H4V10.6L16,4.14l12.53,6.74.94-1.76-13-7a1,1,0,0,0-.94,0l-13,7A1,1,0,0,0,2,10V30H4V24H28v6h2V19A5,5,0,0,0,25,14Zm-8,8V16h8a3,3,0,0,1,3,3v3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hotel.propTypes = iconPropTypes;
}
const Hourglass = /*#__PURE__*/React.forwardRef(function Hourglass({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V21H15z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H17V25H15z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.67V4h3V2H6V4H9v7.67a2,2,0,0,0,.4,1.2L11.75,16,9.4,19.13a2,2,0,0,0-.4,1.2V28H6v2H26V28H23V20.33a2,2,0,0,0-.4-1.2L20.25,16l2.35-3.13A2,2,0,0,0,23,11.67ZM21,4v7H11V4Zm0,16.33V28H11V20.33L14.25,16,12,13h8l-2.25,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Hourglass.propTypes = iconPropTypes;
}
const Html = /*#__PURE__*/React.forwardRef(function Html({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L28 11 26 11 26 21 32 21 32 19 28 19z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11L22 11 20.5 15 19 11 17 11 17 21 19 21 19 14 20.5 18 22 14 22 21 24 21 24 11z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13L11 13 11 21 13 21 13 13 15 13 15 11 9 11 9 13z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11L5 15 2 15 2 11 0 11 0 21 2 21 2 17 5 17 5 21 7 21 7 11 5 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Html.propTypes = iconPropTypes;
}
const HtmlReference = /*#__PURE__*/React.forwardRef(function HtmlReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 6 26 6 26 16 32 16 32 14 28 14z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6L22 6 20.5 10 19 6 17 6 17 16 19 16 19 9 20.5 13 22 9 22 16 24 16 24 6z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8L11 8 11 16 13 16 13 8 15 8 15 6 9 6 9 8z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6L5 10 2 10 2 6 0 6 0 16 2 16 2 12 5 12 5 16 7 16 7 6 5 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  HtmlReference.propTypes = iconPropTypes;
}
const Http = /*#__PURE__*/React.forwardRef(function Http({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11H25V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,30,11Zm-3,5V13h3l.001,3Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L12 13 12 21 14 21 14 13 16 13 16 11 10 11 10 13z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11L17 11 17 13 19 13 19 21 21 21 21 13 23 13 23 11z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11L6 15 3 15 3 11 1 11 1 21 3 21 3 17 6 17 6 21 8 21 8 11 6 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Http.propTypes = iconPropTypes;
}

export { FlashFilled, FlashOff, FlashOffFilled, FlightInternational, FlightRoster, FlightSchedule, FloatingIp, Flood, FloodWarning, Floorplan, Flow, FlowConnection, FlowData, FlowLogsVpc, FlowModeler, FlowModelerReference, FlowStream, FlowStreamReference, Fog, Folder, FolderAdd, FolderDetails, FolderDetailsReference, FolderMoveTo, FolderOff, FolderOpen, FolderParent, FolderShared, Folders, ForLoop, ForecastHail, ForecastHail_30, ForecastLightning, ForecastLightning_30, Fork, ForkNode, Forum, Forward_10, Forward_30, Forward_5, Fragile, Fragments, Friendship, FruitBowl, Function, FunctionMath, Function_2, GameConsole, GameWireless, Gamification, GasStation, GasStationFilled, Gateway, GatewayApi, GatewayMail, GatewayPublic, GatewaySecurity, GatewayUserAccess, GatewayVpn, Gears, Gem, GemReference, GenderFemale, GenderMale, GeneratePdf, Gif, Gift, GlobalLoanAndTrial, Globe, Gradient, GraphicalDataFlow, Grid, Group, GroupAccess, GroupAccount, GroupObjects, GroupObjectsNew, GroupObjectsSave, GroupPresentation, GroupResource, GroupSecurity, Growth, Gui, GuiManagement, Hail, Harbor, HardwareSecurityModule, Hashtag, Haze, HazeNight, Hd, HdFilled, Hdr, Headphones, Headset, HealthCross, Hearing, HeatMap, HeatMapStocks, HeatMap_02, HeatMap_03, Helicopter, Help, HelpDesk, HelpFilled, HexagonOutline, HexagonSolid, HexagonVerticalOutline, HexagonVerticalSolid, Home, HorizontalView, Hospital, HospitalBed, Hotel, Hourglass, Html, HtmlReference, Http, QH, QHintonPlot, WatsonHealthFusionBlender, WatsonHealthHangingProtocol, WatsonHealthHl7Attributes, WatsonHealthHoleFilling, WatsonHealthHoleFillingCursor };
